import { t } from "i18next";

interface LinkedAccountCardCornerBadgeProps {
  label: string;
}

export const LinkedAccountCardCornerBadge = ({ label }: LinkedAccountCardCornerBadgeProps) => {
  return (
    <div className="absolute left-0 top-0 flex h-[20px] items-center justify-center rounded-br-[8px] rounded-tl-[8px] border border-kds-border-solid bg-kds-bg-overlay px-[6px] py-[2px]">
      <span className="whitespace-nowrap text-[12px] font-normal leading-[16px] text-kds-fg-soft">{t(label)}</span>
    </div>
  );
};
